<template>
  <div>
    <HeroSection theme="dashboard">
      <h1 class="text-white">
        Welcome back, <span class="text-warning">{{ $auth.user.name }}</span>
        <a href="#" class="ml-2 font-size-1 text-white" @click="logoff">(Not you? Logout <i class="fas fa-user-slash"></i>)</a>
      </h1>
      <p class="text-white">Use Your Account to manage your properties and track the deals your interested in.</p>
    </HeroSection>
    <div v-if="userWatchers.length === 0" class="container space-1">
      <div class="center-section">
        <h2 class="text-center text-secondary w-90 mb-3">
          You have no properties saved to your account.
        </h2>
        <figure>
          <img class="js-svg-injector img-fluid w-100" alt="Discussion Scene" src="/assets/cmc/svg/illustrations/discussion-scene.svg">
        </figure>
      </div>
    </div>
    <div v-if="userWatchers.length > 0" class="container space-1">
      <div class="row">
        <div class="col-12 mb-4" v-for="item in userWatchers" :key="item.uid">
          <MortgageWatchCard :item="item"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .center-section {
    margin: auto;
    width: 90%;
    padding: 10px;
  }
</style>

<script>
import { mapGetters, mapActions } from "vuex"
import HeroSection from "@/components/layout/HeroSection";
import MortgageWatchCard from "@/components/dashboard/MortgageWatchCard";

export default {
  name: "MyDashboard",
  
  data() {
    return {
      selectedItem: null
    }
  },
  
  components: {
    MortgageWatchCard,
    HeroSection
  },
  
  computed: {
    ...mapGetters([
      "currentUser", "userWatchers"
    ])
  },
  
  methods: {
    ...mapActions([
        "logout"
    ]),
    
    editMortgage(item) {
      console.log(item);
      this.selectedItem = item;
    },

    logoff() {
      this.logout();
      this.$auth.logout({
        returnTo: window.location.origin
      });
    }
  }
}
</script>
